import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { roleColor } from '../../../../lib/reportRoleColors';
import { EditorialSubsection } from '../../report/editorial';

/**
 * Bandwidth capacity — GAP: the interconnection schema has no dedicated
 * bandwidth field, so this surfaces the recommendations list (which
 * typically includes Gbps targets). Gen-side need: a dedicated
 * `bandwidthCapacity` narrative/figure on `interconnectionAnalysis`.
 */
export const BandwidthCapacitySection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const recs = (report.interconnectionAnalysis?.recommendations ?? [])
    .filter((r) => r.trim().length > 0);
  return (
    <SectionShell label={label} hasData={recs.length > 0}>
      {recs.length > 0 && (
        <EditorialSubsection theme={theme} label="Recommendations">
          <ul className="space-y-1.5 list-none pl-0 m-0">
            {recs.map((r, i) => (
              <li key={`bw-${i}`} className="flex items-start gap-2">
                <span
                  className="w-1.5 h-1.5 mt-1.5 shrink-0 rounded-full"
                  style={{ background: roleColor(theme, 'accent') }}
                />
                <span>{r}</span>
              </li>
            ))}
          </ul>
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
